import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { PAGES_PATHS } from '../../page-paths';
import { getTargetUrl } from '../../utils/bread-crumbs';
import { RouteLink } from '../route-link/route-link';

import { BreadCrumbsDropdown } from './bread-crumbs-dropdown';
import { BreadCrumbType } from './bread-crumbs-prop-types';
import { getTrackingData } from './gtm';

import './bread-crumbs.scss';

export function BreadCrumbsUI({ pathItems, isLive, loadData }) {
  return (
    <nav className="sb-BreadCrumbs">
      <ul className="sb-BreadCrumbs-list">
        <li className="sb-BreadCrumbs-item">
          <RouteLink className={clsx('sb-BreadCrumbs-link', isLive && 'isLive')} to={isLive ? PAGES_PATHS.LIVE : '/'}>
            <FormattedMessage id={isLive ? 'sb.general.live' : 'sb.general.home'} />
          </RouteLink>
        </li>
        {pathItems.map(({ key, label, data, breadCrumbType }) => {
          return (
            <li key={breadCrumbType} className="sb-BreadCrumbs-item">
              <span className="sb-BreadCrumbs-slash">/</span>
              <RouteLink
                className="sb-BreadCrumbs-link"
                to={getTargetUrl(breadCrumbType, data, isLive)}
                trackingData={getTrackingData(breadCrumbType)}>
                {label}
              </RouteLink>
              <BreadCrumbsDropdown activeKey={key} isLive={isLive} loadData={loadData} type={breadCrumbType} />
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

BreadCrumbsUI.propTypes = {
  pathItems: PropTypes.arrayOf(BreadCrumbType).isRequired,
  loadData: PropTypes.func.isRequired,
  isLive: PropTypes.bool,
};

BreadCrumbsUI.defaultProps = {
  isLive: false,
};

export const BreadCrumbs = memo(BreadCrumbsUI);
